<template>
<div class="deviceSleep">
  <div class="devcieContainer" :style="styleObject" v-if="JSON.stringify(tabData) == '{}'">
    <!-- <h4>设备列表</h4> -->
    <div class="treeAside">
      <div class="treeTop">
        <span class="treeTopTitle">区域</span>
      </div>
      <div class="treeBox">
        <el-tree
          lazy
          :load="loadData"
          :props="props"
          v-if="1"
          class="tree"
          ref="tree"
          :indent="6"
          node-key="value"
          highlight-current
          :expand-on-click-node="false"
          @node-click="handleNodeSelect">
          <span class="custom-tree-node" slot-scope="{ node }">
            <el-tooltip :content="node.label" placement="right-end" effect="light" :visible-arrow="true">
              <span class="treeLabel" style="width:190px">{{ showLabel(node.label) }}</span>
            </el-tooltip>
          </span>
        </el-tree>
      </div>
    </div>
    <div class="container">
      <div class="query">
        <div class="queryCons">
          <div class="common">
            <el-input placeholder="设备名称/设备类型/IMEI" autocomplete="off" v-model="searchText"></el-input>
            <div class="search" @click="serachData">
              <i><img src="../../assets/img/searchIcon.png" alt=""></i>
            </div>
          </div>
          <!-- <el-select class="common" v-model="keyWords.isInstall" placeholder="是否安装" clearable @change="isInstallChange">
            <el-option label="已安装" :value="1"></el-option>
            <el-option label="未安装" :value="0"></el-option>
          </el-select>
          <el-select class="common" v-model="keyWords.isRegist" placeholder="是否注册" clearable @change="isRegistChange">
            <el-option label="已注册" :value="1"></el-option>
            <el-option label="未注册" :value="0"></el-option>
          </el-select> -->
          <el-select class="common" v-model="keyWords.isOnline" placeholder="是否在线" clearable @change="isOnlineChange">
            <el-option label="在线" :value="true"></el-option>
            <el-option label="离线" :value="false"></el-option>
          </el-select>
          <!-- <el-select class="common" v-model="keyWords.typeId" placeholder="设备类型" clearable>
            <el-option v-for="(item,i) in deviceTypeList" :key="i" :label="item.name" :value="item.id"></el-option>
          </el-select> -->
          <el-select class="common" v-model="keyWords.isAlarm" placeholder="是否报警" clearable @change="isAlarmChange">
            <el-option label="报警" :value="true"></el-option>
            <el-option label="未报警" :value="false"></el-option>
          </el-select>
          <el-select class="common" v-model="keyWords.isFault" placeholder="是否故障" clearable @change="isFaultChange">
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
          <!-- <el-button type="primary" size="medium" @click="handleSetRemoveAll">一键布防</el-button>
          <el-button  type="success" size="medium" @click="handleShowSelect">批量布防</el-button> -->
          <el-button class="delSome" type="primary" size="medium" @click="changeRightCons" icon="el-icon-s-data">实时统计</el-button>
          <!-- <button class="delSome" @click="changeRightCons">
            <i class="imgShow"><img src="../../assets/img/statistics.png" alt=""></i>
            <span>实时统计</span>
          </button> -->
        </div>
      </div>
      <div class="listsContainer" :style="styleObjectCons">
        <!-- :class="changeStatus?'':'active'" -->
        <div class="listsLeft">
          <div v-show="isShowSelect" class="show-sure">
            <el-checkbox v-model="allPage" size="medium" @change="handleCheckAllChange">全部</el-checkbox>
            <el-button class="sure-btn" type="primary" size="mini" @click="handleSelectPart">确定</el-button>
          </div>
          <el-scrollbar wrap-class="scrollbar-wrapper" v-loading="tableLoading">
            <ul class="clearfix cardList">
              <li v-for="(dataInfo,index) in dataList" :key="index">
                <!-- 复选框 -->
                <div class="set-icon" v-if="isShowSelect">
                  <el-checkbox v-model="dataInfo.isSelect" size="medium" />
                </div>
                <!-- 单设备布防 -->
                <span class="set-icon" @click="handleShowSet(dataInfo)" v-else>
                  <i class="el-icon-s-tools"></i>
                </span>
                <div class="sleepReport" @click="handleSleepReport(dataInfo)">睡眠报告</div>
                <p :class="['remove-status', dataInfo.removal ? 'green' : 'gray']">
                  <i></i>{{ dataInfo.removal ? '布防': '撤防' }}</p>
                <card :showFields="fields" :info="dataInfo" @clickEven="clickEven"></card>
              </li>
            </ul>
          </el-scrollbar>
          <div class="noData" v-if="!(dataList&&dataList.length)&&consShow">
            <img src="../../assets/img/noData.png" alt="">
            <div class="tip">暂无数据</div>
          </div>
          <div class="cardPage">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.currentPage" :page-sizes="pagination.pageSizes" :page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="maskingRight" v-if="changeStatus">
    <div class="listsRight" :class="showSlid?'component-slid-open' : 'component-slid-out'">
      <div class="messContainer">
        <div class="cons">
          <!-- <device-right-cons :typeId="deviceTypeId" @closeRightCons="closeRightCons"></device-right-cons> -->
          <device-right-cons :typeId="25" @closeRightCons="closeRightCons"></device-right-cons>
        </div>
      </div>
    </div>
  </div>
  <div class="mainContent" :style="styleObject" v-if="JSON.stringify(tabData) != '{}'">
    <div class="navShow">
      <!-- <i><img src="../../assets/img/setIcon.png" alt=""></i> -->
      <h3 v-if="JSON.stringify(tabData) == '{}'">设备列表</h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <template v-if="JSON.stringify(tabData) != '{}'">
          <el-breadcrumb-item :to="{ path: '/deviceSleep' }">
            <span @click="jumpDev">设备列表</span>
          </el-breadcrumb-item>
          <template>
            <el-breadcrumb-item>{{tabData.name}}</el-breadcrumb-item>
          </template>
        </template>
      </el-breadcrumb>
    </div>
    <div class="tabBox" v-if="sleepShow">
      <tab-block @tabToggle="toggleCom" :pageType="pageType" :tabs="tabs"></tab-block>
    </div>
    <div class="main">
      <component :is="component" :deviceId="deviceId" :deviceImei="deviceImei" type="sleep"></component>
    </div>
  </div>

  <!-- 设置布防撤防时间 -->
  <el-dialog :title="title" :visible.sync="isShowSet" width="440px">
    <div class="dialog-box">
      <!-- <h1 class="title-set-alarm">有人报警</h1> -->
      <ul class="edit-dialog">
        <li>
          <span class="title">开关</span>
          <div class="switch-box">
            <span  class="set" @click="handleSet(0, 'have')">撤防</span>
            <span  class="set" @click="handleSet(1, 'have')">布防</span>
            <span
              class="active"
              ref="active"
              :style="{ background: setParams.removal == false ? '#EE211C' : '#4CC790', left: setParams.removal == false ? '0' : '48px'}"
              >
              {{setParams.removal == false ? "撤防" : "布防"}}
            </span>
          </div>
        </li>
        <li v-show="setParams.removal">
          <span class="title">布防时间</span>
          <el-time-picker
            v-model="setParams.beginTime"
            format="HH:mm"
            value-format="HH:mm"
            @change="handleTimeChange($event, 'have')"
            placeholder="开始时间">
          </el-time-picker> - 
          <el-time-picker
            v-model="setParams.endTime"
            format="HH:mm"
            value-format="HH:mm"
            @change="handleTimeChange($event, 'have')"
            placeholder="结束时间">
          </el-time-picker>
        </li>
      </ul>
      <!-- <h1 class="title-set-alarm">无人报警</h1>
      <ul class="edit-dialog">
        <li>
          <span class="title">开关</span>
          <div class="switch-box">
            <span  class="set" @click="handleSet(0, 'none')">撤防</span>
            <span  class="set" @click="handleSet(1, 'none')">布防</span>
            <span
              class="active"
              ref="activeNone"
              :style="{ background: setParams.unmannedDeviceRemoval == false ? '#EE211C' : '#4CC790', left: setParams.unmannedDeviceRemoval == false ? '0' : '48px'}"
              >
              {{setParams.unmannedDeviceRemoval == false ? "撤防" : "布防"}}
            </span>
          </div>
        </li>
        <li v-show="setParams.unmannedDeviceRemoval">
          <span class="title">无人时间</span>
          <el-input-number v-model="setParams.effectiveTime" controls-position="right"></el-input-number>
          <span> 小时</span>
        </li>
        <li v-show="setParams.unmannedDeviceRemoval">
          <span class="title">布防开始时间</span>
          <el-time-picker
            v-model="setParams.unmannedBeginTime"
            format="HH:mm"
            value-format="HH:mm"
            @change="handleTimeChange($event, 'none')"
            placeholder="开始时间">
          </el-time-picker> - 
          <el-time-picker
            v-model="setParams.unmannedEndTime"
            format="HH:mm"
            value-format="HH:mm"
            @change="handleTimeChange($event, 'none')"
            placeholder="结束时间">
          </el-time-picker>
        </li>
        <p class="tip">{{tip}}</p>
      </ul> -->
      <!-- <ul class="edit-dialog">
        <li>
          <span class="title">开关</span>
          <div class="switch-box">
            <span  class="set" @click="handleSet(0)">撤防</span>
            <span  class="set" @click="handleSet(1)">布防</span>
            <span
              class="active"
              ref="active"
              :style="{ background: setParams.removal == false ? '#EE211C' : '#4CC790', left: setParams.removal == false ? '0' : '48px'}"
              >
              {{setParams.removal == false ? "撤防" : "布防"}}
            </span>
          </div>
        </li>
        <li v-show="setParams.removal">
          <span class="title">布防开始时间</span>
          <el-time-picker
            v-model="setParams.startTime"
            format="HH:mm"
            value-format="HH:mm"
            @change="handleTimeChange"
            placeholder="布防开始时间">
          </el-time-picker>
        </li>
        <li v-show="setParams.removal">
          <span class="title">布防结束时间</span>
          <el-time-picker
            v-model="setParams.endTime"
            format="HH:mm"
            value-format="HH:mm"
            @change="handleTimeChange"
            placeholder="布防结束时间">
          </el-time-picker>
        </li>
        <p class="tip">{{tip}}</p>
      </ul> -->
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleSave">保 存</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
import TabBlock from '@/components/common/TabBlock'
import BasicInfo from '@/views/deviceManagement/deviceDetails/BasicInfo'
import sleepReport from '@/views/deviceManagement/deviceDetails/sleepReport'
import DeviceDatas from '@/views/deviceManagement/deviceDetails/DeviceDatas'
import IssueCommand from '@/views/deviceManagement/deviceDetails/IssueCommand'
import AlarmRecord from '@/views/deviceManagement/deviceDetails/AlarmRecord'
import FaultRecord from '@/views/deviceManagement/deviceDetails/FaultRecord'
import InstallRecord from '@/views/deviceManagement/deviceDetails/InstallRecord'
import DeviceRightCons from '@/views/deviceManagement/gatewayChild/DeviceRightCons'
import Card from '@/views/deviceManagement/deviceSmoke/Card'
export default {
  name: 'deviceSleep',
  components: {
    TabBlock,
    BasicInfo,
    DeviceDatas,
    IssueCommand,
    AlarmRecord,
    FaultRecord,
    InstallRecord,
    Card,
    DeviceRightCons,
    sleepReport
  },
  data() {
    return {
      treeData: [],
      searchText: '',
      keyWords: {
        isAlarm: "",
        isFault: "",
        isInstall: "",
        isOnline: "",
        isRegist: "",
        typeId: ''
      },
      options: [{
        value: '1',
        label: '在线'
      }, {
        value: '0',
        label: '离线'
      }],
      component: '',
      tabs: [{
          name: '基本信息',
          code: 'BasicInfo'
        }, {
          name: '设备数据',
          code: 'DeviceDatas'
        },
        // {
        //   name: '下发命令',
        //   code: 'IssueCommand'
        // },
        {
          name: '报警记录',
          code: 'AlarmRecord'
        }, {
          name: '故障记录',
          code: 'FaultRecord'
        }, {
          name: '安装记录',
          code: 'InstallRecord'
        }
      ],
      pageType: 'DeviceGas',
      styleObject: {
        height: ''
      },
      styleObjectCons: {
        height: ''
      },
      tabData: {},
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 12,
        pageSizes: [12, 22, 32],
        total: 0
      },
      dataList: [],
      deviceTypeList: [],
      fields: [],
      tableLoading: true,
      deviceId: null,
      getEchartStatus: '',
      deviceImei: '',
      changeStatus: false,
      consShow: false,
      currentTreeId: '',
      showSlid: false,
      deviceTypeId:0,
      props: {
        label: 'label',
        children: 'children',
        isLeaf: 'isLeaf'
      },
      isShowSet: false,
      isShowSelect: false,
      allPage: false,
      setParams: {
        deviceId: '',
        // startTime: null,
        // endTime: null,
        // removal: true,
        
        removal: false,  // 布防撤防
        beginTime: '',  // 开始时间
        endTime: '',  // 结束时间
        // isAll: false, // 是否是一键布防撤防（false:批量布防，需要看deviceId）
        key: '', // 搜索条件1
        isOnline: '', // 搜索条件-是否在线
        isAlarm: '', // 搜索条件-是否报警
        isFault: '', // 搜索条件-是否故障
        orgId: ''
      },
      title: '设备布防',
      tip: '',
      sleepShow: true,
    }
  },
  created() {
    this.makeheight()
    this.makeheightCons()
    let addd = this.$route.query.data
    if (this.$route.query.data) {
      this.sleepShow = false
      this.tabData = {
        name: '睡眠报告',
        code: 'sleepReport'
      }
      this.component = this.tabData.code
      this.deviceId = Number(this.$route.query.data.deviceId)
    }
    // this.queryTreeNode()
    // this.initData()
    // this.getDeviceType()
  },
  methods: {
    showLabel(label) {
      if (!label) {
        return label;
      }
      return label;
    },
    // // 查询组织
    // queryTreeNode(pid = 0) {
    //   this.request.get(`/front/system/organization/findTreeById?id=${pid}`)
    //     .then(rs => {
    //       // console.log(rs);
    //       this.treeData = rs.code === 200 ? rs.data : [];
    //       this.currentTreeId = this.treeData.length > 0 ? this.treeData[0].value : 0;
    //     })
    //     .catch(error => (this.treeData = []));
    // },
    // 查询区域
    queryTreeNode(pid = 0) {
      this.request.get(`/front/device/region/findTreeById?id=${pid}`)
        .then(rs => {
          // console.log(rs);

          this.treeData = rs.code === 200 ? rs.data : [];
          this.currentTreeId = this.treeData.length > 0 ? (this.treeData[0].value?this.treeData[0].value:0):0;
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(this.treeData[0].value)
          })
          this.initData()
        })
        .catch(error => (this.treeData = []));
    },
    // 查询区域
    loadData (node, resolve) {
      if (node.level === 0) {
        let root = { id: 0, label: '区域机构', parentId: 0, value: 0 }
        
        //默认展开第一层根节点---节点渲染完成后，加载第二层节点的核心代码
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(0)
          let nodedata = node.childNodes[0];
          nodedata.expanded = true;
          nodedata.loadData();
        })
        resolve([root])
      } else {
        let pid = node.data ? node.data.id : 0

        this.request.get(`/front/device/region/findTreefenjiById?id=${pid}`).then(rs => {
          let data = rs.code === 200 ? rs.data : []

          // 区域-终端出库设备
          if (node.level == 1) {
            data.unshift({ id: -1, label: '终端出库设备', parentId: 0, value: -1, isLeaf: true })
          }

          this.initData()
          resolve(data)
          
        }).catch(error => {
          console.error(error)
          let temp = node.level == 1 ? [{ id: -1, label: '终端出库设备', parentId: 0, value: -1, isLeaf: true }] : []
          resolve(temp)
          // resolve([])
        })        
      }
    },    
    // 节点点击发生变化时，触发事件
    handleNodeSelect(item) {
      this.currentTreeId = item ? (item.value ? item.value : 0) : 0;
      this.pagination.currentPage = 1;
      this.initData();
    },
    getDeviceType() {
      this.request.post('/front/device/type/query', {
          page: 1,
          pageSize: 1000
        }).then(res => {
          // console.log(res);
          if (res.code === 200) {
            this.deviceTypeList = res.data.data ? res.data.data : []
          } else if (res.code === 500) {
            this.deviceTypeList = []
            this.msg.warn(res.msg)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    serachData() {
      //查询//搜索
      this.getEchartStatus = this.keyWords.typeId
      this.searchText = this.searchText.replace(/(^\s*)|(\s*$)/g, "")
      this.pagination.currentPage = 1
      this.initData()
    },
    initData() {
      this.consShow = false
      this.params = {
        key: this.searchText,
        page: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        orgId: this.currentTreeId ? this.currentTreeId : 0,
        typeId: this.keyWords.typeId,
        isInstall: this.keyWords.isInstall,
        isAlarm: this.keyWords.isAlarm,
        isFault: this.keyWords.isFault,
        isRegist: this.keyWords.isRegist,
        isOnline: this.keyWords.isOnline,
      }
      let url = this.params.orgId == -1 ? '/front/device/sleep/queryOutbound' : "/front/device/sleep/query"
      this.request.get(url, this.params)
        .then(res => {
          // console.log(123, res)
          if (res.code === 200) {
            this.tableLoading = false
            this.consShow = true
            let temp = res.data ? res.data : []
            this.pagination.total = res.total
            this.dataList = temp.map(item=>{
              this.fields = [
                {
                  field: 'isFault',
                  name: '设备状态'
                }, {
                  field: 'imei',
                  name: 'IMEI'
                }, {
                  field: 'isOnline',
                  name: '在线状态'
                }, {
                  field: 'isAlarm',
                  name: '报警状态'
                }, {
                  field: 'bedState',
                  name: '在床状态'
                },{
                  field: 'installLocation',
                  name: '安装位置'
                },
              ]
              return { ...item, isSelect: false }
            })
          } else if (res.code === 500) {
            this.dataList = []
            this.msg.warn(res.msg)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    jumpDev() {
      this.tabData = {}
      this.initData()
    },
    toggleCom(tabCode) {
      // console.log(tabCode);
      this.tabData = tabCode
      this.component = tabCode.code
    },
    clickEven(val) {
      // console.log(8888, val);
      this.tabData = {
        name: '基本信息',
        code: 'BasicInfo'
      }
      this.deviceId = val.deviceId
      this.deviceImei = val.imei
      this.sleepShow = this.treeData
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和makeheightCons
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    makeheightCons(height = 210) {
      let _this = this;
      _this.styleObjectCons.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObjectCons.height = window.innerHeight - height + "px";
        })();
      };
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.initData()
    },
    handleSizeChange(val) {
      this.pagination.currentPage = 1
      this.pagination.pageSize = val
      this.initData()
    },
    changeRightCons() {
      if (!this.changeStatus) {
        this.changeStatus = true
        this.showSlid = true
      } else {
        this.showSlid = false
        setTimeout(() => {
          this.changeStatus = this.showSlid
        }, 440)
      }
    },
    closeRightCons(data){
      this.showSlid = false
        setTimeout(() => {
          this.changeStatus = data
        }, 440)
    },
    isInstallChange(){
      this.pagination.currentPage = 1
      this.initData()
    },
    isRegistChange(){
      this.pagination.currentPage = 1
      this.initData()
    },
    isOnlineChange(){
      this.pagination.currentPage = 1
      this.initData()
    },
    isAlarmChange(){
      this.pagination.currentPage = 1
      this.initData()
    },
    isFaultChange(){
      this.pagination.currentPage = 1
      this.initData()
    },
    /**
     * @Description 切换布防or撤防
     * @Author      YOYO     -             2022-8-1
     */
    handleSet (type, havePeople) {
      let temp = [
        { text: '撤防', color: '#EE211C', left: '0px', deviceRemoval: false },
        { text: '布防', color: '#4CC790', left: '48px', deviceRemoval: true }
      ]
      if (havePeople == 'have') {
        this.setParams.removal = type == 1
        let dom = this.$refs.active
        dom.style = `left: ${temp[type].left};background: ${temp[type].color}`
      }
    },
    /**
     * @Description 单设备布防
     * @Author      YOYO     -             2022-8-4
     */    
    handleShowSet (item) {
      this.isShowSet = true
      this.title = '设备布防'
      this.isShow = false
      this.tip = ''
      let { removal, deviceId, beginTime, endTime } = item
      this.setParams = {
        deviceId: deviceId,
        removal,
        beginTime: beginTime || '09:00',
        endTime: endTime || '18:00',
        key: '',
        isOnline: '',
        isAlarm: '',
        isFault: '',
        orgId: ''
      }
    },
    /**
     * @Description 设备批量布防
     * @Author      YOYO     -             2022-08-05
     */
    handleShowSelect () {
      if (this.dataList.length <= 0) {
        return this.$message({ type: 'warning', message: '没有可布防的设备！'})
      }

      this.isShowSelect = !this.isShowSelect

      this.title = '设备批量布防'
      this.setParams = {
        deviceId: '',
        removal: false,
        beginTime: '',
        endTime: '',
        key: '',
        isOnline: '',
        isAlarm: '',
        isFault: '',
        orgId: ''
      }
      this.handleCheckAllChange(false)
    },
    /**
     * @Description 一键布防 isAll: true,
     * @Author      YOYO     -             2022-08-05
     * @return      {[type]} [description]
     */
    handleSetRemoveAll () {
      if (this.dataList.length <= 0) {
        return this.$message({ type: 'warning', message: '没有可布防的设备！'})
      }
      this.isShowSet = true
      this.isShowSelect = false
      this.title = '一键布防'
      this.tip = `注意： 此操作将对所筛选的全部设备生效(共${this.pagination.total}台)`
      let { searchText, currentTreeId, keyWords: { isAlarm, isFault, isOnline }} = this

      this.setParams = {
        deviceId: '',
        removal: false,
        beginTime: '',
        endTime: '',
        isAll: true,
        key: searchText,
        orgId: currentTreeId ? currentTreeId : 0,
        isAlarm,
        isFault,
        isOnline
      }
    },
    /**
     * @Description 时间更改
     * @Author      YOYO     -             2022-08-08
     */
    handleTimeChange (e, type) {
      const { beginTime, endTime } = this.setParams


      if (type == 'have' && beginTime && endTime) {
        if (endTime < beginTime) {
          this.$message({ type: 'success', message: `布防时间为${beginTime} 至次日${endTime}！` })
        } else if (endTime == beginTime) {
          this.$message({ type: 'success', message: '24小时布防！' })
        }
      }
    },
    /**
     * @Description 设置保存
     * @Author      YOYO     -             2021-11-27
     */
    handleSave () {
      const { beginTime, endTime, removal } = this.setParams
      if (removal && (beginTime == '' || endTime == '')) {
        return this.$message({ type: 'warning', message: '布防时间不能为空！' })
      }

      const userId = this.storage.getSession("userId")

      this.request.post('/front/device/sleep/removal', {
        // ...this.setParams, userId
        beginTime: this.setParams.beginTime,
        endTime: this.setParams.endTime,
        removal: this.setParams.removal,
        deviceId: this.setParams.deviceId,
        userId: userId,
      }).then(res => {
        if (res.code == 200) {
          this.isShowSet = false
          this.isShowSelect = false
          this.allPage = false

          this.initData()
          this.$message({ type: 'success', message: '保存成功' })
        } else {
          this.$message({ type: 'warning', message: res.msg })
        }
      }).catch(e => {
        this.$message({ type: 'error', message: e })
      })
    },
    /**
     * @Description 批量布防撤防-确定
     * @Author      YOYO     -             2022-09-14
     */
    handleSelectPart () {
      let temp = []
      this.dataList.forEach(({ isSelect, deviceId }) => {
        if (isSelect) temp.push(deviceId)
      })
      this.setParams.deviceId = temp.join(',')
      if (!temp.length) {
        return this.$message({ type: 'warning', message: '请选择设备！' })
      }
      this.tip = `注意： 此操作将对您已选择的设备生效(共${temp.length})`

      this.isShowSet = true
    },
    /**
     * @Description 本页全选
     * @Author      YOYO     -             2021-11-27
     */
    handleCheckAllChange (e) {
      let temp = JSON.parse(JSON.stringify(this.dataList))
      this.dataList = temp.map(item => {
        return { ...item, isSelect: e }
      })
    },
    // 点击跳转睡眠报告页面
    handleSleepReport (data) {
      this.sleepShow = false
      this.tabData = {
        name: '睡眠报告',
        code: 'sleepReport'
      }
      this.component = this.tabData.code
      this.deviceId = data.deviceId
      this.deviceImei = data.imei
    },
  }
};
</script>

<style lang="scss" scoped>
.deviceSleep {
  // position: relative;
  ::v-deep .el-dialog__wrapper {
    .el-dialog {
      .el-dialog__header {
        padding: 0;
        background-color: #1E2639;
        .el-dialog__title {
          color: #fff;
          font-size: 14px;
          line-height: 40px;
          margin-left: 22px;
        }
        .el-dialog__headerbtn {
          top: 13px;
          >i {
            color: #fff;
          }
        }
      }
    }
  }
  .navShow {
    // margin-left: 20px;
    overflow: hidden;
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid #f2f2f2;

    i {
      float: left;
      width: 16px;
      height: 16px;
      margin-right: 4px;

      img {
        width: 100%;
        height: 100%;
        vertical-align: unset;
      }
    }

    h3 {
      float: left;
      font-size: 16px;
      line-height: 16px;
      font-weight: 500;
      color: #7A7D81;
    }

    span {
      float: left;
      font-size: 16px;
      font-weight: 500;
      color: #7A7D81;
    }
  }

  .devcieContainer {
    margin: 10px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;

    h4 {
      padding-bottom: 10px;
    }

    .container {
      padding: 0 10px 0 300px;
    }

    .query {
      padding-bottom: 10px;

      .queryCons {
        width: 100%;
        overflow: hidden;

        .common {
          float: left;
          margin-bottom: 5px;
          position: relative;
          .search{
            position: absolute;
            right: 10px;
            top: 0px;
            width: 40px;
            height: 40px;
            font-size: 0;
            z-index: 10;
            text-align: center;
            cursor: pointer;
            i{
              display: inline-block;
              width: 16px;
              height: 16px;
              cursor: pointer;
              margin-top: 12px;
              img{
                width: 100%;
                height: 100%;
              }
            }
          }
        }

        .primaryBtn {
          width: 82px;
          height: 40px;
          cursor: pointer;
          margin-right: 20px;
          font-size: 14px;
          line-height: 40px;
          border: 0;
          color: #FFFFFF;
          background: #1089FF;
          border-radius: 2px;

          &:hover {
            background: #0774e0;
          }
        }

        .delSome {
          // width: 102px;
          // cursor: pointer;
          float: right;
          margin-left: 5px;
          margin-bottom: 4px;
          // font-size: 0;
          // padding: 0 10px;
          // border: 0;
          // color: #FFFFFF;
          // background: #1089FF;
          // border-radius: 2px;
          // outline: unset;
          // overflow: hidden;

          // &:hover {
          //   background: #0774e0;
          // }

          // .imgShow {
          //   float: left;
          //   width: 16px;
          //   height: 16px;
          //   margin: 10px 6px 0 0;

          //   img {
          //     width: 100%;
          //     height: 100%;
          //     vertical-align: middle;
          //   }

          //   &.active {
          //     transform: rotate(180deg);
          //   }
          // }

          // span {
          //   float: left;
          //   font-size: 14px;
          //   line-height: 40px;
          // }
        }
      }
    }

    .listsContainer {
      overflow: hidden;
      position: relative;

      .listsLeft {
        float: left;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 0 0 60px;
        position: relative;
        background: #f2f2f2;
        .noData {
          position: absolute;
          top: 50%;
          left: 50%;
          margin-left: -150px;
          margin-top: -150px;
          text-align: center;

          img {
            width: 300px;
            height: 300px;
          }

          .tip {
            margin-top: 10px;
            font-size: 18px;
            color: #bbb;
          }
        }
        .show-sure {
          padding: 0 20px;
          height: 40px;
          line-height: 40px;
          background-color: #eaeaea;
          .sure-btn {
            float: right;
            margin-top: 6px;
          }
        }

        .cardList {
          height: 100%;
          width: 100%;
          position: relative;

          .set-icon {
            position: absolute;
            top: 22px;
            right: 18px;
            z-index: 1;
            font-size: 20px;
            color: #409EFF;
            cursor: pointer;
          }
          .sleepReport {
            width: 75px;
            height: 25px;
            text-align: center;
            line-height: 25px;
            background-color: #409eff;
            color: #fff;
            position: absolute;
            top: 60px;
            right: 18px;
            border-radius: 40px;
            z-index: 1;
            cursor: pointer;

          }
          .remove-status {
            position: absolute;
            top: 113px;
            right: 20px;
            z-index: 1;
            padding: 4px 25px;
            border-radius: 15px;
            i {
              position: absolute;
              left: 9px;
              top: 11px;
              width: 6px;
              height: 6px;
              border-radius: 50%;
            }
            &.green {
              background-color: #E6F8F2;
              color: #08BB80;
              i {
                background-color: #08BB80;
              }
            }
            &.gray {
              color: #B8BABC;
              background-color: #EEEFEF;
              i {
                background-color: #B8BABC;
              }
            }
          }
          &>li {
            float: left;
            width: 314px;
            height: 230px;
            padding: 10px;
            box-sizing: border-box;
            position: relative;
          }
        }

        .cardPage {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 50px;
          text-align: center;
          padding: 10px 0;
          box-sizing: border-box;
        }

        &.active {
          width: 100%;

          .cardList {
            height: 100%;
            width: 100%;
            overflow-x: hidden;
            overflow-y: auto;

            &>li {
              float: left;
              width: 20%;
              height: 240px;
            }
          }
        }
      }

    }
  }
  .maskingRight{
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0,0.4);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    .listsRight {
      position: absolute;
      right: 12px;
      top: 0;
      width: 740px;
      height: 100%;
      z-index: 9999;
      box-shadow: -2px 0 10px #ccc;
      background: #fff;

      &.component-slid-open {
        position: absolute;
        top: 0;
        right: 0;
        width: 740px;
        height: 100%;
        background: #fff;
        opacity: 1;
        animation: slid-open 0.5s ease;
      }

      &.component-slid-out {
        position: absolute;
        top: 0;
        right: 0;
        width: 740px;
        height: 100%;
        background: #fff;
        animation: slid-out 0.5s ease;
      }

      .messContainer {
        width: 100%;
        height: 100%;
        // padding-left: 10px;
        box-sizing: border-box;

        .cons {
          width: 100%;
          height: 100%;
          // background: #f3f3f3;
          // background: rgba(243,243,243,1);
        }
      }
    }
  }
  .mainContent {
    margin: 12px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    // overflow: auto;
    .main {
      height: calc(100% - 47px);
    }
  }

  .dialog-box {
    .title-set-alarm {
      font-size: 14px;
      color: #409EFF;
    }
    .edit-dialog {
      margin-bottom: 10px;
      margin-left: 15px;
      li {
        margin-top: 20px;
        .title {
          font-size: 14px;
          color: #333;
          display: inline-block;
          width: 100px;
        }
        .el-input {
          width: 120px;
          line-height: 40px;
          height: 40px;
        }
        .el-input-number__decrease, .el-input-number__increase {
          bottom: 4;
        }
        .el-input-number {
          &.is-controls-right .el-input-number__decrease, &.is-controls-right .el-input-number__increase {
            line-height: 15px;
          }
          &.is-controls-right .el-input-number__decrease {
            bottom: 4;
          }
        }
        .switch-box {
          display:inline-block;
          position: relative;
          top: 5px;
          // right: 30px;
          border-radius: 25px;
          overflow: hidden;
          line-height: 20px;
          font-size: 12px;
          background: #F3F3F3;
          color: #bbb;
          .set {
            cursor: pointer;

          }
          span {
            display: inline-block;
            width: 50px;
            text-align: center;
          }
          .active {
            width: 52px;
            border-radius: 25px;
            position: absolute;
            top: 0px;
            left:0px;
            color: #fff;
            background: #EE211C;
            transition: 0.3s;
          }
        }
      }
      .tip {
        color: red;
        margin-top: 20px;
        font-size: 12px;
      }
    }  
  }

  @keyframes slid-open {
    0% {
      transform: translateX(100%);
      opacity: 0;
    }

    100% {
      transform: translateX(0);
    }
  }

  @keyframes slid-out {
    0% {
      width: 600px;
      transform: translateX(0)
    }

    100% {
      transform: translateX(100%)
    }
  }
}
</style>
<style lang="scss">
.deviceSleep {
  .devcieContainer {
    position: relative;
    .query {
      // padding-left: 10px;

      .el-input {
        width: 260px;
        margin-right: 10px;
        .el-input__inner {
          line-height: 40px;
          height: 40px;
          // border:none;
          // outline: none;
        }
      }

      .el-select {
        width: 170px;
        margin-right: 10px;

        .el-input {
          width: 170px;
          margin-right: 10px;

          .el-input__inner {
            line-height: 40px;
            height: 40px;
            // border:none;
            // outline: none;
          }
        }
      }
    }

    .el-loading-mask {
      background-color: unset;
    }

    .treeAside {
      position: absolute;
      width: 300px;
      height: 100%;
      padding: 0px 10px 10px 10px;
      left: 0;
      top: 0;
      box-sizing: border-box;

      .treeTop {
        width: 280px;
        position: absolute;
        height: 40px;
        line-height: 40px;
        font-size: 0;
        font-weight: bold;
        top: 15px;
        z-index: 10;
        // background: #fff;
        padding-left: 20px;
        box-sizing: border-box;

        .treeTopTitle {
          margin-right: 115px;
          // width: 500px;
          font-size: 18px;
          color: #333;
        }

        .el-button {
          margin-left: -24px;
        }

        .complete {
          margin-left: 10px;
        }
      }

      .treeBox {
        overflow: hidden;
        height: calc(100% - 15px);
        border: 1px solid #ebeef5;
        padding: 40px 10px 10px;
        box-sizing: border-box;
        background: #fff;
        margin-top: 15px;
      }

      .tree {
        height: 100%;
        overflow: auto;

        .el-tree-node__content {
          height: 40px;
        }

        .custom-tree-node {
          height: 40px;
          line-height: 40px;
          width: 100%;

          .treeLabel {
            font-size: 14px;
            display: inline-block;
            width: 130px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .treeBtn {
            float: right;

            .el-button {
              margin-left: 0;
            }
          }
        }
      }
    }
  }

  .el-breadcrumb {
    display: inline-block;
    padding: 0;
    font-family: AlibabaPuHuiTi-Medium;
  }

  .el-breadcrumb__inner a,
  .el-breadcrumb__inner.is-link {
    color: #7A7D81;
    font-size: 16px;
    font-weight: 500;
  }

  .el-breadcrumb__separator {
    font-size: 16px;
    color: #7A7D81;
    margin: 0 5px;
    font-weight: 500;
  }

  .el-breadcrumb__inner {
    font-size: 16px;
    color: #7A7D81 !important;
    font-weight: 500 !important;
  }
  .el-checkbox__inner {
    border-radius: 50%;
    width: 20px;
    height: 20px;
    &::after {
    height: 9px;
    left: 6px;
    top: 3px;
    width: 5px;
    }
  }

  .el-input-number.is-controls-right .el-input-number__decrease {
    bottom: 4px;
  }
  .el-input-number.is-controls-right .el-input-number__decrease, .el-input-number.is-controls-right .el-input-number__increase {
    line-height: 15px;
  }
  .el-input-number__decrease, .el-input-number__increase {
    top: 4px;
  }
}
</style>
